"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListActionVariant = void 0;
var ListActionVariant;
(function (ListActionVariant) {
    ListActionVariant["button"] = "button";
    ListActionVariant["iconButton"] = "iconButton";
    ListActionVariant["menuItem"] = "menuItem";
})(ListActionVariant || (exports.ListActionVariant = ListActionVariant = {}));
//# sourceMappingURL=interface.js.map